<div class="app-card__icon">
  @if (iconName; as ic) {
    <i eIcon [icon]="ic"></i>
  }
  @if (!iconName) {
    <i class="demo-icon">&#xe800;</i>
  }
</div>
<div class="app-card__text">
  <div class="app-card__name">{{ app.name }}</div>
  @if (app.poolName) {
    <div class="app-card__subtitle">{{ app.poolName }}</div>
  }
</div>
@if (active) {
  <div class="app-card__badge app-card__badge--active">ACTIVE</div>
}
